const EmailAddress = (val) => {
    const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\s*$/i;
    const valid = !val || regex.test(val);

    return [
        valid,
        valid ? null : 'Please enter a valid email address',
    ]
}

export default EmailAddress;
